module.exports = __webpack_public_path__ + "img/icon_1_color@2x.933fab14.png";